import { useField } from "formik";
import { TTFormInputProps } from "./input.types";
import { InputBase } from "./InputBase";
import { useState } from "react";

export const InputGpsCoordinates = (props: TTFormInputProps) => {
  const [field, , helpers] = useField(props.id);
  const [inputValue, setInputValue] = useState(
    `${field.value.latitude},${field.value.longitude}`
  );
  const allowedPattern = /^([+-]?\d{1,2}(?:\.\d+)?),([+-]?\d{1,3}(?:\.\d+)?)$/;

  const handleChange = (event: any) => {
    let value = event.target.value;
    const caretPosition = event.target.selectionStart;

    if (!value.includes(",")) {
      window.requestAnimationFrame(() => {
        event.target.selectionStart = caretPosition +1;
        event.target.selectionEnd = caretPosition + 1;
      });
      return;
    }

    const partialPattern =
      /^([+-]?\d{0,2}(?:\.\d{0,5})?),?([+-]?\d{0,3}(?:\.\d{0,5})?)?$/;
    if (!partialPattern.test(value)) {
      window.requestAnimationFrame(() => {
        event.target.selectionStart = caretPosition;
        event.target.selectionEnd = caretPosition - 1;
      });
      return;
    }

    const [latitude, longitude] = value.split(",").map(Number);

    if(latitude > 90 || latitude < -90 || longitude > 180 || longitude < -180) {
      window.requestAnimationFrame(() => {
        event.target.selectionStart = caretPosition;
        event.target.selectionEnd = caretPosition - 1;
      });
      return;
    }

    setInputValue(value);

    if (allowedPattern.test(value)) {


      const newValue = {
        ...field.value,
        latitude: latitude || 0,
        longitude: longitude || 0,
      };
      helpers.setValue(newValue);
    }

    setTimeout(() => {
      event.target.setSelectionRange(caretPosition, caretPosition);
    }, 0);
  };

  const newProps = {
    ...props,
    name: `${props.id}.latitude`,
    value: inputValue,
    onChange: handleChange,
  };
  return <InputBase {...newProps} />;
};
